import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AutomationLayer from "../components/AutomationLayer";

const Automation = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Chatbot" />
      <AutomationLayer />
    </MasterLayout>
  );
};

export default Automation;
